import * as apiClient from "./axiosApiClient";
import { joinUrlWithRoute } from "../utils/urlUtils";

const baseUrl = apiClient.REACT_APP_USER_API_BASE_URL;

export function signup(request) {
    const url = joinUrlWithRoute(baseUrl, "/register");
    return apiClient.post(url, request);
}